export const GET_ADMIN_EVENT_REQUESTS_REQUEST =
  "GET_ADMIN_EVENT_REQUESTS_REQUEST";
export const GET_ADMIN_EVENT_REQUESTS_RESPONSE =
  "GET_ADMIN_EVENT_REQUESTS_RESPONSE";
export const GET_ADMIN_EVENT_REQUESTS_SUMMARY_RESPONSE =
  "GET_ADMIN_EVENT_REQUESTS_SUMMARY_RESPONSE";
export const BULK_APPROVE_ADMIN_EVENT_REQUESTS_REQUEST =
  "BULK_APPROVE_ADMIN_EVENT_REQUESTS_REQUEST";
export const BULK_REJECT_ADMIN_EVENT_REQUESTS_REQUEST =
  "BULK_REJECT_ADMIN_EVENT_REQUESTS_REQUEST";
export const BULK_ALLOCATE_ADMIN_EVENT_REQUESTS_REQUEST =
  "BULK_ALLOCATE_ADMIN_EVENT_REQUESTS_REQUEST";
export const BULK_UNASSIGN_ADMIN_EVENT_REQUESTS_REQUEST =
  "BULK_UNASSIGN_ADMIN_EVENT_REQUESTS_REQUEST";
export const BULK_REMOVE_ADMIN_EVENT_REQUESTS_REQUEST =
  "BULK_REMOVE_ADMIN_EVENT_REQUESTS_REQUEST";
export const BULK_CHANGE_ROLE_ADMIN_EVENT_REQUESTS_REQUEST =
  "BULK_CHANGE_ROLE_ADMIN_EVENT_REQUESTS_REQUEST";
